import classNames from 'classnames';
import React from 'react';
import Icon from '../Icon';
import { PaginationItemLinkProps } from './PaginationItemLinkProps';
import { PaginationLabels } from './translations';

interface PaginationArrowProps {
  labels: PaginationLabels;
  itemLink: (props: PaginationItemLinkProps) => JSX.Element;
  current: number;
  itemOnClick: (page: number) => void;
  variant: 'previous' | 'next';
}

export default function PaginationArrow({
  labels,
  itemLink: ItemLink,
  itemOnClick,
  current,
  variant,
}: PaginationArrowProps): JSX.Element {
  const pageIndex = variant === 'previous' ? current - 1 : current + 1;
  return (
    <li className="usa-pagination__item usa-pagination__arrow">
      <ItemLink
        className={classNames('usa-pagination__link', {
          'usa-pagination__previous-page': variant === 'previous',
          'usa-pagination__next-page': variant === 'next',
        })}
        aria-label={`${variant === 'previous' ? labels.previousLabel : labels.nextLabel} ${labels.pageLabel}`}
        page={pageIndex}
        onClick={() => itemOnClick(pageIndex)}
      >
        {variant === 'previous' ? (
          <>
            <Icon name="navigate_before" />
            <span className="usa-pagination__link-text"> {labels.previousLabel} </span>
          </>
        ) : null}
        {variant === 'next' ? (
          <>
            <span className="usa-pagination__link-text"> {labels.nextLabel} </span>
            <Icon name="navigate_next" />
          </>
        ) : null}
      </ItemLink>
    </li>
  );
}
